import React from 'react';
import A, { AnchorProps } from '@sls-react/components/Links/A';
import { Link } from '@sls-react/routing';
import qsStringify from '@sls-react/utils/qsStringify';

type Props = AnchorProps & {
  prefilledForm?: any;
};

const ValueGuideLink: React.FC<Props> = ({
  children,
  prefilledForm,
  ...props
}) => (
  <Link href={'/value-guide' + qsStringify(prefilledForm)} passHref>
    <A rel="nofollow noindex" {...props}>
      {children}
    </A>
  </Link>
);

export default ValueGuideLink;
